import { render, staticRenderFns } from "./AppTabs.vue?vue&type=template&id=eb5f39b0&scoped=true&"
import script from "./AppTabs.vue?vue&type=script&lang=js&"
export * from "./AppTabs.vue?vue&type=script&lang=js&"
import style0 from "./AppTabs.vue?vue&type=style&index=0&id=eb5f39b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5f39b0",
  null
  
)

export default component.exports